import React from 'react';
import { Grid } from '@material-ui/core';
import { Colors } from 'library';
import JobCardChip from './JobCardChip';

interface ChipType {
    text: string;
    flag: boolean;
    color: Colors;
    textColor: Colors;
    tooltipHeader: string;
    tooltipText: string;
}

const JobCardChips = ({ chips }: { chips: Array<ChipType> }) => {
    const getJobChip = (chip: ChipType) =>
        chip.flag ? (
            <JobCardChip
                color={chip.color}
                textColor={chip.textColor}
                text={chip.text}
                style={{ marginBottom: 8, marginRight: 4 }}
            />
        ) : null;

    return (
        <Grid container direction="row" style={{ marginBottom: 10, marginRight: 16 }}>
            {chips.map((chip) => getJobChip(chip))}
        </Grid>
    );
};

export default JobCardChips;
